"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var activeClass = 'cat-list_item--active';
    var $iconFilter = $('.product-categories__filter');
    var $productWrapperContent = $('.product-categories__content');
    var $categoryBtn = $('.cat-list_item');
    var $productListContainer = $('#product-loop');
    enableEvents();
    checkWidth();
    function enableEvents() {
        $categoryBtn.on('click', function () {
            $categoryBtn.removeClass(activeClass);
            $(this).addClass(activeClass);
            $productListContainer.addClass('loading');
            $.ajax({
                async: true,
                type: 'POST',
                url: '/wp/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'filter_projects',
                    type: 'product',
                    category: $(this).data('slug'),
                },
                success: function (res) {
                    $productListContainer.html(res);
                    $productListContainer.removeClass('loading');
                }
            });
        });
        $(window).on("resize", checkWidth);
        $iconFilter.on('click', function () {
            $productWrapperContent.find("a:not(.".concat(activeClass, ")")).fadeToggle(400);
            $iconFilter.toggleClass('fa-bars');
            $iconFilter.toggleClass('fa-times');
        });
    }
    function checkWidth() {
        var inactiveItems = $productWrapperContent.find("a:not(.".concat(activeClass, ")"));
        $(window).width() <= 768 ? inactiveItems.fadeOut() : inactiveItems.fadeIn();
    }
};
exports.init = init;
